<template>
  <div style="margin-left:50px;">
    <a-transfer
    :list-style="{
      width: '400px',
      height: '500px',
    }"
      :data-source="project.unit_all"
      :titles="['可选单位', '已选单位']"
      :selected-keys="selectedKeys"
      :target-keys="project.unit_selected_key_list"
      :render="item => item.name"
      :disabled="disabled"
      @change="handleChange"
      @selectChange="handleSelectChange"
      @scroll="handleScroll"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: "ProjectAddUnit",
  props: {
     project: Object
  },
  data() {
    return {
      selectedKeys: [],
      disabled: false
    };
  },
  methods: {
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.project.unit_selected_key_list = nextTargetKeys;
      this.project.unit_seleccted_list=this.project.unit_all.filter(item=>{
        return this.project.unit_selected_key_list.indexOf(item.id)!=-1
      })
      console.log("project.unit_selected_key_list: ", project.unit_selected_key_list);
      console.log("this.project.unit_seleccted_list: ", this.project.unit_seleccted_list);
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    handleScroll(direction, e) {
      console.log("direction:", direction);
      console.log("target:", e.target);
    },
    handleDisable(disabled) {
      this.disabled = disabled;
    }
  }
};
</script>

<style>

</style>